exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footBtn[data-v-a6d64e66]{position:absolute;width:100%;bottom:0}.page[data-v-a6d64e66]{text-align:left}", ""]);

// exports
